export default __webpack_public_path__ + "static/media/2.3b99a973.mp3";